module.exports = __webpack_public_path__ + "components/rewards/offline-maps/static/logo-6293a55f9a2098e40bfbee84764c7b95.jpg";